import { connectMediaStore } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getGallectionDeviationStreamId } from '../helpers';
import { fetchMoreGallectionDeviations } from '../actions';
import { getCurrentFolderId, getCurrentSubfolderId, getSearchQuery, getCurrentMediaSource } from '../selectors';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
const mapStateToProps = (state)=>{
    const mediaSourceType = getCurrentMediaSource(state);
    const currentFolderId = getCurrentFolderId(state);
    const currentSubfolderId = getCurrentSubfolderId(state);
    const searchQuery = getSearchQuery(state);
    const streamId = getGallectionDeviationStreamId(mediaSourceType, currentSubfolderId || currentFolderId, searchQuery);
    return {
        deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
        hasMore: selectors.hasMore(state, streamId),
        isInitialized: selectors.isInitialized(state, streamId),
        isFetching: selectors.isFetching(state, streamId)
    };
};
export default connectMediaStore(mapStateToProps, {
    fetchMoreGallectionDeviations
});
